<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<mat-dialog-content>
  <p>
    {{ dialogContent }}
  </p>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-flat-button color="accent" (click)="cancel()">Cancel</button>
  <section class="action-buttons">
    <button mat-flat-button color="accent" (click)="startNewApplication()">
      {{ actionButtons.start }}
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="continueApplication()"
      cdkFocusInitial
    >
      {{ actionButtons.continue }}
    </button>
  </section>
</mat-dialog-actions>
